import { ListedInstrument, WatchListGroup, WatchListInstrumentFull } from '@eih-netbroker/common';
import { useCallback } from 'react';
import { ReactComponent as BookmarkFill } from '../../../assets/icons/bookmark-fill.svg';
import { ReactComponent as BookmarkLine } from '../../../assets/icons/bookmark_line.svg';
import { useLocale } from '../../../context/NbLocalizationContext';
import { Config } from '../../config/config';
import { cssWhen } from '../../utils/themeUtils';
import classes from './InstrumentSearchModalWatchlistRow.module.scss';

export interface InstrumentSearchModalWatchlistPopoverProps {
  instrument: ListedInstrument | null;
  watchListGroup: WatchListGroup;
  onRemove: (watchListGroup: WatchListGroup, instrument: WatchListInstrumentFull) => void;
  onAdd: (watchListGroup: WatchListGroup, instrument: ListedInstrument) => void;
}

export const InstrumentSearchModalWatchlistRow = ({
  watchListGroup,
  instrument,
  onRemove,
  onAdd,
}: InstrumentSearchModalWatchlistPopoverProps) => {
  const isContains = watchListGroup.items.some(i => i.instrument.ric === instrument?.ric);
  const isFull = watchListGroup.items.length >= Config.NetBroker.Watchlist.MaxItemsOnWatchlist;
  const { translation } = useLocale();
  const onHandleClick = useCallback(() => {
    if (isFull && !isContains) {
      return;
    }

    if (isContains) {
      const watchListInstrument = watchListGroup.items.find(i => i.instrument.ric === instrument?.ric);
      if (watchListInstrument) {
        onRemove(watchListGroup, watchListInstrument);
      }
    } else {
      onAdd(watchListGroup, instrument!);
    }
  }, [watchListGroup, instrument, isContains, isFull, onRemove, onAdd]);

  return (
    <div
      onClick={onHandleClick}
      className={cssWhen(classes.row, [isFull, classes.rowIsDisable], [isContains && isFull, classes.rowIsRemovable])}
    >
      <span className={classes.rowTitle}>{watchListGroup.name}</span>
      <div className={cssWhen(classes.rowRightContainer, [isContains, classes.rowRightContainerIsSelected])}>
        {isFull && <span className={classes.rowFullText}>{translation.instrument.saveToWatchlist.full}</span>}
        {isContains ? <BookmarkFill /> : <BookmarkLine />}
      </div>
    </div>
  );
};
